function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import Position from './Position';
var Depth = /*#__PURE__*/function () {
  function Depth() {
    _classCallCheck(this, Depth);
    Depth.constructor_.apply(this, arguments);
  }
  return _createClass(Depth, [{
    key: "getDepth",
    value: function getDepth(geomIndex, posIndex) {
      return this._depth[geomIndex][posIndex];
    }
  }, {
    key: "setDepth",
    value: function setDepth(geomIndex, posIndex, depthValue) {
      this._depth[geomIndex][posIndex] = depthValue;
    }
  }, {
    key: "isNull",
    value: function isNull() {
      if (arguments.length === 0) {
        for (var i = 0; i < 2; i++) {
          for (var j = 0; j < 3; j++) {
            if (this._depth[i][j] !== Depth.NULL_VALUE) return false;
          }
        }
        return true;
      } else if (arguments.length === 1) {
        var geomIndex = arguments[0];
        return this._depth[geomIndex][1] === Depth.NULL_VALUE;
      } else if (arguments.length === 2) {
        var _geomIndex = arguments[0];
        var posIndex = arguments[1];
        return this._depth[_geomIndex][posIndex] === Depth.NULL_VALUE;
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < 2; i++) {
        if (!this.isNull(i)) {
          var minDepth = this._depth[i][1];
          if (this._depth[i][2] < minDepth) minDepth = this._depth[i][2];
          if (minDepth < 0) minDepth = 0;
          for (var j = 1; j < 3; j++) {
            var newValue = 0;
            if (this._depth[i][j] > minDepth) newValue = 1;
            this._depth[i][j] = newValue;
          }
        }
      }
    }
  }, {
    key: "getDelta",
    value: function getDelta(geomIndex) {
      return this._depth[geomIndex][Position.RIGHT] - this._depth[geomIndex][Position.LEFT];
    }
  }, {
    key: "getLocation",
    value: function getLocation(geomIndex, posIndex) {
      if (this._depth[geomIndex][posIndex] <= 0) return Location.EXTERIOR;
      return Location.INTERIOR;
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'A: ' + this._depth[0][1] + ',' + this._depth[0][2] + ' B: ' + this._depth[1][1] + ',' + this._depth[1][2];
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var lbl = arguments[0];
        for (var i = 0; i < 2; i++) {
          for (var j = 1; j < 3; j++) {
            var loc = lbl.getLocation(i, j);
            if (loc === Location.EXTERIOR || loc === Location.INTERIOR) {
              if (this.isNull(i, j)) {
                this._depth[i][j] = Depth.depthAtLocation(loc);
              } else this._depth[i][j] += Depth.depthAtLocation(loc);
            }
          }
        }
      } else if (arguments.length === 3) {
        var geomIndex = arguments[0];
        var posIndex = arguments[1];
        var location = arguments[2];
        if (location === Location.INTERIOR) this._depth[geomIndex][posIndex]++;
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Depth;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "depthAtLocation",
    value: function depthAtLocation(location) {
      if (location === Location.EXTERIOR) return 0;
      if (location === Location.INTERIOR) return 1;
      return Depth.NULL_VALUE;
    }
  }]);
}();
export { Depth as default };
Depth.constructor_ = function () {
  this._depth = Array(2).fill().map(function () {
    return Array(3);
  });
  for (var i = 0; i < 2; i++) {
    for (var j = 0; j < 3; j++) {
      this._depth[i][j] = Depth.NULL_VALUE;
    }
  }
};
Depth.NULL_VALUE = -1;